import type {FC} from 'react';
import {useState} from 'react';
import {Box} from '@wellstone-solutions/web';
import {Modal} from '@mui/material';

import {CreateWizard} from '../CreateWizard';
import {AccessControl} from 'modules/rbac';
import {useStores} from 'hooks/useStores';
import {ActionButton} from 'components/PageHeader';
import {useFeatureFlag, LD_FLAGS} from 'modules/feature-flags';

export const AddStaffButton: FC = () => {
  const [showModal, setShowModal] = useState(false);
  const {RBACStore} = useStores();
  const emrManagedUsers = useFeatureFlag(LD_FLAGS.EMR_MANAGED_USERS);

  if (!RBACStore.hasAccess(AccessControl.staff.addStaff) || emrManagedUsers) {
    return null;
  }

  const toggleModal = (event: object, reason: string) => {
    if (reason !== 'backdropClick') {
      setShowModal(!showModal);
    }
  };

  return (
    <Box>
      <ActionButton
        onClick={() => setShowModal(true)}
        label="New Staff"
        testId="add-new-staff-button"
      />

      <Modal open={showModal} onClose={toggleModal}>
        <div>
          <CreateWizard onCancel={toggleModal} />
        </div>
      </Modal>
    </Box>
  );
};
